module.exports = __webpack_public_path__ + "img/copygreen.47c07caf.png";